<template>
  <div id="init">
  </div>
</template>
<script>

    export default {
        name: 'Init',
        props: ['path'],
        data() {
          return{
            countDown: 30,
          };
        },
        methods: {
          countDownTimer() {
                      if(this.countDown > 0) {
                          setTimeout(() => {
                              this.countDown -= 1
                              this.countDownTimer()
                          }, 1000)
                      } else {
                        // eslint-disable-next-line no-console
                        this.$analytics.fbq.event('on there for 1+ minute')
                      }
                  },
          setLanguage(){
            if (window.location.host == "rho-17.com"){
              this.$store.dispatch("setLanguage", "EN");
            }
            // this.$store.dispatch("setLanguage", "EN");
          }
        },
        computed: {
          isMobile(){
            return this.$store.getters.getAnimationProperties.mobile;
          },
        },
        created () {
          this.countDownTimer()
        },
        mounted() {
          this.setLanguage()
          switch (this.path) {
            case "table":
              if (this.isMobile) {
                this.$router.push('/configuratorTableMobile');
              } else {
                this.$router.push('/configuratorTableDesktop');
              }
            break
            case "bench":
              if (this.isMobile) {
                this.$router.push('/configuratorBenchMobile');
              } else {
                this.$router.push('/configuratorBenchDesktop');
              }
            break
            case "stool":
              if (this.isMobile) {
                this.$router.push('/configuratorStoolMobile');
              } else {
                this.$router.push('/configuratorStoolDesktop');
              }
            break
            case "shelf":
              if (this.isMobile) {
                this.$router.push('/configuratorShelfMobile');
              } else {
                this.$router.push('/configuratorShelfDesktop');
              }
            break
            default:
              if (this.isMobile) {
                this.$router.push('/homeMobile');
              } else {
                this.$router.push('/homeDesktop');
              }
            break;
          }
        }
    }
</script>
<style scoped>
</style>
